import React, { Fragment, useContext, type ReactElement } from 'react';
import { getTranslation } from '../utils/config';
import { useDfContext } from '../context/df-context';
import slugify from 'slugify';
import { DfCategoriesContext } from '../context/categories/df-categories-context';

export default function FilterPillCategory({
  selection = undefined,
  depth = 1,
}: {
  selection?: number;
  depth?: number;
}): ReactElement | null {
  const {
    state: { countedCategories, selected },
    setSelected,
  } = useDfContext();
  const data = useContext(DfCategoriesContext);

  if (!data || Object.keys(data.categories).length === 0) {
    return null;
  }

  const cacheKey = selection || 'root';
  const categoryItem =
    cacheKey === 'root'
      ? data.categories[data.rootCategory.toString()]
      : data.categories[cacheKey.toString()];

  if (categoryItem.children.length === 0) {
    return null;
  }

  const getTitle = () => {
    if (depth === 2) {
      return getTranslation('filter_select_category');
    }
    if (categoryItem.displayname && depth > 2) {
      return getTranslation('filter_select_area_2', categoryItem.displayname);
    }
    return getTranslation('filter_select_area');
  };

  return (
    <Fragment key={cacheKey}>
      <fieldset className={`df-detail-fieldset df-detail-search-modal__area-0${depth}`}>
        <legend>{getTitle()}</legend>
        <div className="df-filters df-detail-fieldset__labels">
          {categoryItem.children.map((childId) => {
            const filter = data.categories[childId];

            return (
              <label key={filter.pimId}>
                <input
                  type="radio"
                  name={`c-${depth}`}
                  className="df-detail-search-modal__radio"
                  value={filter.pimId}
                  onClick={() => {
                    if (!countedCategories.includes(filter.pimId)) return;

                    setSelected?.(depth, filter.pimId);
                  }}
                  checked={selected[depth] === filter.pimId}
                  readOnly
                  disabled={!countedCategories.includes(filter.pimId)}
                />
                <span
                  className={`df-filter-pill df-icon-fallback df-icon-${slugify(
                    String(filter.pimName),
                    { lower: true },
                  )} ${!countedCategories.includes(filter.pimId) ? 'df-filter-pill--disabled' : ''}`}
                >
                  {filter.displayname}
                </span>
              </label>
            );
          })}
        </div>
      </fieldset>
      {selected[depth] ? (
        <FilterPillCategory selection={selected[depth]} depth={depth + 1} />
      ) : null}
    </Fragment>
  );
}
